// Any character should be escaped using the
// backslash "\" in terms for solr search
export const escapeContent = value =>
  // eslint-disable-next-line no-useless-escape
  value && value.replace(/[.*+-?!@#^${}()|[\]\\\ ]/g, '\\$&');
